export default "__VITE_ASSET__014534bb__"